export default __webpack_public_path__ + "static/media/bp-external-bol.d15a38c9.png";